import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private requestCount = 0;
  public loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  private messageSubject = new BehaviorSubject<string>('');
  message$ = this.messageSubject.asObservable();

  show(message: string = ''): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.loadingSubject.next(true);
    }
    if (message) {
      this.messageSubject.next(message);
    }
  }

  hide(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
    }

    if (this.requestCount === 0) {
      this.loadingSubject.next(false);
      this.messageSubject.next('');
    }
  }

  setMessage(message: string): void {
    this.messageSubject.next(message);
  }

  reset(): void {
    this.requestCount = 0;
    this.loadingSubject.next(false);
    this.messageSubject.next('');
  }
}
